import { useRequest } from 'ahooks';
import { AppSettingResponse, getConfig } from '@/lib/api/methods';
import { createContext, JSX, useContext } from 'react';

import { LanguageContext } from './languageContext';
import { NotificationContext } from './notificationContext';

type ContextProps = {
  data: AppSettingResponse;
  loading: boolean;
};

export const AppSettingsContext = createContext({} as ContextProps);

export const AppSettingsProvider = ({
  children,
}: {
  children: JSX.Element;
}) => {
  const { countryCode, language } = useContext(LanguageContext);
  const { openNotificationWithIcon } = useContext(NotificationContext);
  const { data, loading } = useRequest(() => getConfig(), {
    ready: !!countryCode && !!language,
    refreshDeps: [countryCode, language],
    onError: (err: any) => {
      openNotificationWithIcon(
        'error',
        err?.response?.data?.message || err.message
      );
    },
  });
  return (
    <AppSettingsContext.Provider value={{ data, loading }}>
      {children}
    </AppSettingsContext.Provider>
  );
};
